import { IAimStatus } from '@common/interfaces/user'
import moment from 'moment'

/**
 * What hovering a status emoji says: the status itself, and when it lapses.
 *
 * The emoji alone is rarely self-explanatory — 🌴 is vacation or a beach-house
 * deal — and "until when" is the half that decides whether to wait for someone
 * or ping them anyway. It is nowhere on screen otherwise, since the row has
 * space for a glyph and nothing more.
 *
 * The clock time alone within today, the weekday ahead of it beyond that: "until
 * 1:30 PM" is unambiguous this afternoon and useless on a status running to
 * Thursday.
 */
export const formatAimStatusTooltip = (status: IAimStatus | null | undefined): string => {
  if (!status) return ''

  const stated = [status.emoji, status.text].filter(Boolean).join(' ')
  if (!status.expiresAt) return stated

  const expiresAt = moment(status.expiresAt)
  // A stored timestamp we cannot parse is not worth surfacing as "Invalid date";
  // the status itself still reads fine without it.
  if (!expiresAt.isValid()) return stated

  const clearsAt = expiresAt.isSame(moment(), 'day')
    ? expiresAt.format('h:mm A')
    : expiresAt.format('ddd h:mm A')

  return stated ? `${stated} · until ${clearsAt}` : `Until ${clearsAt}`
}
